// extracted by mini-css-extract-plugin
export default {"DialogContent":"needAuthDialog_component_DialogContent__CPgNU","DialogActionButtons":"needAuthDialog_component_DialogActionButtons__mNZzh"};